import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { BaseService } from '../base/base.service';
import { SessionUserHashManagerService } from '../session-user-hash-manager/session-user-hash-manager.service';
import { StudentBooking } from '../../_models/student-bookings/student-booking';
import { MergeLessonSummaryRequest, MergeLessonSummaryStudentDetails } from '../../_models/student-bookings/merge-lesson-summary-request.model';

@Injectable({
  providedIn: 'root'
})
export class StudentBookingsService extends BaseService {

  private apiUrl: string = environment.apiUrl;

  constructor(
    private http: HttpClient,
    protected hashManagerService: SessionUserHashManagerService
  ) {
    super(hashManagerService);
    this.apiUrl += this.apiUrl.endsWith("/") ? "" : "/";
  }

  getStudentBooking(placementId: number, startDate: Date, startTime: any) {

    let model = {
      "PlacementId": placementId,
      "StartDate": startDate,
      "StartTime": startTime
    };

    return this.http.post(this.apiUrl + 'api/LearningSection/RetrieveLearnerSession', 
    model,
    this.prepareOptions(model))
      .pipe(
        map((data: any) => {
          return data.body;
        }), catchError(this.handleError('getStudentBooking'))
      );
  }

  mergeStudentBooking(studentBooking: StudentBooking) {
    let model = this.lessonSummaryModelMapper(studentBooking);
    return this.http.post(this.apiUrl + 'api/LearningSection/MergeLearnerSession',
      model,
      this.prepareOptions(model)).pipe(
        map((data: any) => {

          return data.body;
        }), catchError(this.handleError('mergeStudentBooking'))
      );
  }

  retrieveStudentProgression(studentId: number[], subject: string, placementId: number) {
    let requestBody = { studentID: studentId, subject: subject, placementId: placementId };
    return this.http.post(this.apiUrl + 'api/Students/ReadStudentProgression',
      requestBody,
      this.prepareOptions(requestBody)).pipe(
        map((data: any) => {
          return data.body;
        }), catchError(this.handleError('retrieveStudentProgression'))
      );
  }

  private lessonSummaryModelMapper(modelToMap: StudentBooking): MergeLessonSummaryRequest {
    let model = new MergeLessonSummaryRequest();
    model.sessionId = modelToMap.sessionId;
    model.tutorId = modelToMap.tutorId;
    model.placementId = +modelToMap.placementId;
    model.subject = modelToMap.subject;
    model.lessonSummary = modelToMap.lessonSummary;
    model.startDate = modelToMap.startDate;
    model.startTime = modelToMap.startTime;
    model.endTime = modelToMap.endTime;
    model.statusDescription = modelToMap.status;
    model.lessonType = modelToMap.lessonType;

    model.studentDetails = modelToMap.studentDetails.map(s => {
      let student = new MergeLessonSummaryStudentDetails();
      student.id = s.id;
      student.studentId = s.studentId;
      student.studentName = s.studentFullName;
      student.attendance = s.attendance;
      student.engagement = s.engagement;
      student.comprehension = s.comprehension;
      student.reasonDescription = s.reasonDescription;
      student.learnerComments = s.learnerComments;
      return student;
    })

    return model;
  }
}
